import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AccountComponent } from './components/account.component';
import { AppsHomeComponent } from './components/apps-home.component';
import { ExpandedAccessComponent } from './components/expanded-access.component';
import { FeedbackWidgetComponent } from './components/feedback-widget.component';
import { FooterComponent } from './components/footer.component';
import { HeaderComponent } from './components/header.component';
import { LandingComponent } from './components/landing.component';
import { LimitModalComponent } from './components/limit-modal.component';

@NgModule({
	declarations: [
		AppComponent,
		HeaderComponent,
		FooterComponent,
		FeedbackWidgetComponent,
		LimitModalComponent,
		LandingComponent,
		AccountComponent,
		AppsHomeComponent,
		ExpandedAccessComponent,
	],
	imports: [BrowserModule, FormsModule, HttpClientModule],
	providers: [],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
